import * as React from 'react'
import { ComponentExt } from '@utils/reactExt'
import * as styles from './style/index.scss'
import { WhiteSpace, InputItem, Checkbox, Picker, ActionSheet } from 'antd-mobile'
import VeritcalLineTitle from '@componentsG/veritcalLineTitle'
import { FormattedMessage } from 'react-intl'
import intl from '@utils/intl';
import { deepClone, isEmail } from '@src/utils';
import { cyberSourcePay } from '@utils/cyberSourcePay'
import USA_STATES from './actor/USA_state'
import { observer, inject } from 'mobx-react'
import { userStore } from '@src/store/userStore'
import { TRYBUY_EVENT_TRACING_PAGE, TRYBUY_EVENT_TRACING_CLICK } from '@src/constants'
const AgreeItem = Checkbox.AgreeItem;
import { createForm, formShape } from 'rc-form';

interface BillAddressProps {
    form: formShape
}

@inject('addressStoreG')
@observer
class BillAddress extends ComponentExt<BillAddressProps, any> {
    private readonly userInfo: any = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
    private params: any
    private checkOutId: string = ''
    private store
    constructor(props) {
        super(props)
        this.params = props.match.params
        this.store = props.addressStoreG
        this.state = {
            historyBillingAddress: null,
            checked: false,
        };
        sessionStorage.setItem('paymentId', '');
        this.store.initOrderStatus()
        this.store.getPayScript()
        this.store.getCheckout(false)
    }

    async componentDidMount() {
        await this.getHistoryBillingAddress()
    }
    componentWillUnmount() { }
    getHistoryBillingAddress = async () => {
        this.showLoading()
        try {
            const res = await this.api.currentBillInfo({})
            this.setState({
                historyBillingAddress: res && Object.keys(res).length !== 0 ? {
                    firstName: res.firstName,
                    lastName: res.lastName,
                    name: `${res.firstName} ${res.lastName}`,
                    email: res.email,
                    street: res.street,
                    city: res.city,
                    stateName: this.params.countryCode === 'US' ? this.getStateTitle(res.state) : res.state,
                    stateCode: res.state,
                    postCode: res.postCode,
                    country: res.country
                } : null
            })
        } catch (e) {
            console.error(e)
        } finally {
            this.hideLoading()
        }
    }

    selectBillingAddress = e => {
        this.props.form.setFieldsValue({
            firstName: e.target.checked ? this.state.historyBillingAddress.firstName : '',
            lastName: e.target.checked ? this.state.historyBillingAddress.lastName : '',
            email: e.target.checked ? this.state.historyBillingAddress.email : '',
            street: e.target.checked ? this.state.historyBillingAddress.street : '',
            city: e.target.checked ? this.state.historyBillingAddress.city : '',
            state: e.target.checked ? this.state.historyBillingAddress.stateCode : '',
            postCode: e.target.checked ? this.state.historyBillingAddress.postCode : ''
        })
        this.setState({
            checked: e.target.checked
        })
    }

    doContinue = () => {
        this.props.form.validateFields(async (error, value) => {
            if (!error) {
                userStore.sendEventTracing({
                    pageCode: '',
                    buttonCode: TRYBUY_EVENT_TRACING_CLICK.TRYBUY_BILL_ADDRESS_CLICK_CONTINUE,
                    buttonInfo: ''
                })
                await this.generateOrderForTp(value)
            }
        })
    }

    callAciPay = async (orderId: string, useOriCard: string) => {
        const checkoutId = await this.api.getCheckoutId({ orderId: orderId, oneClick: useOriCard });
        this.checkOutId = checkoutId
        const script = document.createElement('script');
        script.src = `https://${this.store.payScriptUrl}/v1/paymentWidgets.js?checkoutId=${this.checkOutId}`;
        document.body.appendChild(script);
        this.store.getCheckOutId(checkoutId, orderId)
        this.store.getCheckout(true)
    }

    // 生成订单
    generateOrderForTp = async (params) => {
        const isCye = await this.api.isCybersource({ iccid: this.userInfo.iccid })
        const param = {
            simId: this.userInfo.iccid,
            paymentType: isCye === '0' ? '4' : '3',
            goodsReleaseId: this.params.goodsReleaseId,
            activityId: this.params.activityId,
            cargoType: this.params.goodsType === '1' ? this.params.cargoType : undefined,
            areaCode: this.params.countryCode
        }

        try {
            this.showLoading()
            await this.api.insertBillInfo({ ...params, country: this.params.countryCode })
            const orderId = await this.api[this.params.goodsType === '0' ? 'gobuyPlan' : 'buySpeedPlan'](param)
            if (isCye === '0') { // ACI 支付
                const haveCard = await this.api.aciCheckBillInfo({ orderId: orderId });
                if (haveCard === '0') { // 新卡直接唤起
                    this.callAciPay(orderId, String(haveCard))
                } else {
                    ActionSheet.showActionSheetWithOptions({
                        title: intl.formatMessage({ id: 'billAddress.tips.payment', defaultMessage: 'How to pay?' }),
                        options: [
                            intl.formatMessage({ id: 'billAddress.tips.newCard', defaultMessage: 'New Card' }),
                            intl.formatMessage({ id: 'billAddress.tips.oldCard', defaultMessage: 'Old Card' }),
                        ]
                    },
                        (type) => {
                            this.callAciPay(orderId, String(type))
                        })
                }
            } else { // cybersoures 支付
                const res1 = await this.api.payvalidation({ orderId: orderId })
                const { post_url } = res1
                const obj = deepClone(res1)
                obj.bill_to_address_state = obj.bill_to_address_state || ''
                delete obj.post_url
                await cyberSourcePay(post_url, obj)
            }
        } catch (e) {
        } finally {
            this.hideLoading()
        }
    }

    // 根据的州的code找到对应的label
    getStateTitle = code => {
        return USA_STATES.find(item => item.value === code) ? USA_STATES.find(item => item.value === code).label : ''
    }
    handleCancel = () => {
        this.goBack()
        userStore.sendEventTracing({
            pageCode: '',
            buttonCode: TRYBUY_EVENT_TRACING_CLICK.TRYBUY_BILL_ADDRESS_CLICK_CANCEL,
            buttonInfo: ''
        })
    }
    render() {
        const { getFieldProps, setFieldsValue, getFieldValue } = this.props.form;
        return (
            <div>
                {/* todo 动态获取域名方便测试*/}
                {this.store.isCheckout &&
                    <div className={styles.wpwl_checkout}>
                        <form id="aci" action={`https://${window.location.host}/?chl=tabletApp#/global/result-aci`} className="paymentWidgets" data-brands="VISA MASTER" />
                    </div>
                }
                {
                    this.state.historyBillingAddress &&
                    <HistoryBillingAddress
                        checked={this.state.checked}
                        historyBillingAddress={this.state.historyBillingAddress}
                        countryName={this.params.countryName}
                        selectBillingAddress={this.selectBillingAddress}
                    />
                }
                <section className={styles.fieldWrap}>
                    <VeritcalLineTitle messageId="billAddress.fieldWrap.title" />
                    <div style={{ padding: '0 10px', marginTop: 20, boxSizing: 'border-box' }}>
                        <FormItemC
                            form={this.props.form}
                            dataIndex="firstName"
                            labelMessageId="billAddress.field.firstName"
                            required
                        >
                            <InputItem
                                {...getFieldProps('firstName', {
                                    rules: [{
                                        required: true,
                                        message: intl.formatMessage({ id: 'billAddress.field.firstNameError' })
                                    }]
                                })}
                                className={styles.inputItem}
                            />
                        </FormItemC>
                        <FormItemC
                            form={this.props.form}
                            dataIndex="lastName"
                            labelMessageId="billAddress.field.lastName"
                            required
                        >
                            <InputItem
                                {...getFieldProps('lastName', {
                                    rules: [{
                                        required: true,
                                        message: intl.formatMessage({ id: 'billAddress.field.lastNameError' })
                                    }]
                                })}
                                className={styles.inputItem}
                            />
                        </FormItemC>
                        <FormItemC
                            form={this.props.form}
                            dataIndex="email"
                            labelMessageId="billAddress.field.email"
                            required
                        >
                            <InputItem
                                {...getFieldProps('email', {
                                    rules: [{
                                        validator: (rules, value, callack) => {
                                            if (!value) {
                                                callack(new Error(intl.formatMessage({ id: 'billAddress.field.emailError' })))
                                            } else if (!isEmail(value)) {
                                                callack(new Error(intl.formatMessage({ id: 'billAddress.field.emailFormatError' })))
                                            } else {
                                                callack()
                                            }
                                        }
                                    }]
                                })}
                                className={styles.inputItem}
                            />
                        </FormItemC>
                        <FormItemC
                            form={this.props.form}
                            dataIndex="street"
                            labelMessageId="billAddress.field.street"
                            required
                        >
                            <InputItem
                                {...getFieldProps('street', {
                                    rules: [{
                                        required: true,
                                        message: intl.formatMessage({ id: 'billAddress.field.streetError' })
                                    }]
                                })}
                                className={styles.inputItem}
                            />
                        </FormItemC>
                        <FormItemC
                            form={this.props.form}
                            dataIndex="city"
                            labelMessageId="billAddress.field.city"
                            required
                        >
                            <InputItem
                                {...getFieldProps('city', {
                                    rules: [{
                                        required: true,
                                        message: intl.formatMessage({ id: 'billAddress.field.cityError' })
                                    }]
                                })}
                                className={styles.inputItem}
                            />
                        </FormItemC>
                        <FormItemC
                            form={this.props.form}
                            dataIndex="state"
                            labelMessageId="billAddress.field.state"
                            required={this.params.countryCode === 'US'}
                        >
                            {
                                this.params.countryCode === 'US' ?
                                    <Picker
                                        data={USA_STATES}
                                        cols={1}
                                        value={[getFieldValue('state')]}
                                        extra={' '}
                                        okText={intl.formatMessage({ id: 'common.sure' })}
                                        dismissText={intl.formatMessage({ id: 'common.cancel' })}
                                        onChange={value => setFieldsValue({ state: value[0] })}
                                    >
                                        <div>
                                            <InputItem
                                                className={styles.inputItem}
                                                editable={false}
                                                value={this.getStateTitle(getFieldValue('state'))}
                                            />
                                            <InputItem
                                                {...getFieldProps('state', {
                                                    rules: [{
                                                        required: true,
                                                        message: intl.formatMessage({ id: 'billAddress.field.stateError' })
                                                    }]
                                                })}
                                                className={`${styles.inputItem} ${styles.stateValue}`}
                                                editable={false}
                                            />
                                        </div>
                                    </Picker>
                                    :
                                    <InputItem
                                        {...getFieldProps('state')}
                                        className={styles.inputItem}
                                    />

                            }
                        </FormItemC>
                        <FormItemC
                            form={this.props.form}
                            dataIndex="postCode"
                            labelMessageId="billAddress.field.postCode"
                            required
                        >
                            <InputItem
                                {...getFieldProps('postCode', {
                                    rules: [{
                                        required: true,
                                        message: intl.formatMessage({ id: 'billAddress.field.postCodeError' })
                                    }]
                                })}
                                type={'number'}
                                className={styles.inputItem}
                            />
                        </FormItemC>
                        <FormItemC
                            form={this.props.form}
                            dataIndex="country"
                            labelMessageId="billAddress.field.country"
                            required
                        >
                            <span className={styles.countryField}>{this.params.countryCode}</span>
                        </FormItemC>
                    </div>
                </section>
                <section className={styles.btnWrap}>
                    <div className={styles.cancelBtn} onClick={this.handleCancel}>
                        <FormattedMessage id="billAddress.btn.cancel" />
                    </div>
                    <div className={styles.continueBtn} onClick={this.doContinue}>
                        <FormattedMessage id="billAddress.btn.continue" />
                    </div>
                </section>
            </div >
        )
    }
}

interface FormItemCProps {
    form: any
    children?: any
    required?: boolean
    labelMessageId: string
    dataIndex: string
}

const FormItemC = (props: FormItemCProps) => {
    const { getFieldError } = props.form;
    return (
        <div className={styles.fieldItem}>
            <span className={styles.formItemLabel} data-required={props.required ? ' *' : ''}>
                <FormattedMessage id={props.labelMessageId} />
            </span>
            <div className={`${styles.formItemChild} ${styles[!!getFieldError(props.dataIndex) ? 'formItemChildError' : 'formItemChildDefault']}`}>
                {props.children}
            </div>
            <span className={styles.errorMessage}>{getFieldError(props.dataIndex)}</span>
        </div>
    )
}
const HistoryBillingAddress = (props) => (
    <>
        <section className={styles.historyAddressWrap}>
            <VeritcalLineTitle messageId="billAddress.history.title" />
            <div
                className={styles.addressInnerWrap}
                style={{ backgroundColor: props.checked ? '#FEF7F3' : '#F9F9F9' }}
            >
                {
                    props.historyBillingAddress && Object.keys(props.historyBillingAddress).map(key => (
                        key !== 'firstName' && key !== 'lastName' && key !== 'country' && key !== 'stateCode' &&
                        <span key={key}>{props.historyBillingAddress[key] || '-'}</span>
                    ))
                }
                <span>{props.countryName}</span>
                <div className={styles.checkBox}>
                    <AgreeItem onChange={props.selectBillingAddress} />
                </div>
            </div>
        </section>
        <WhiteSpace className={styles.whiteSpace} />
    </>
)
export default createForm()(BillAddress)
